<div fxLayout="row" class="care-team-expanded">
  <div fxLayout="col" fxFlex="100" class="care-team-details">
    <nz-layout>
      <nz-header>{{ "Members" | translate }}</nz-header>
      <nz-content>
        @if (item.participants && item.participants.length) {
          @for (participant of item.participants; track participant.userId) {
            <div fxLayout="row" class="detail-row">
              <div fxLayout="col" fxFlex="40" class="detail-label">
                {{ participant.userDisplayName }}
              </div>
              <div fxLayout="col" fxFlex="40" class="detail-info">
                {{ participant.careTeamRoleDisplay }}
              </div>
              <div fxLayout="col" fxFlex="20" class="detail-info">
                @if (participant.displayOrder) {
                  #{{ participant.displayOrder }}
                }
              </div>
            </div>
          }
        } @else {
          <div fxLayout="row" class="detail-row">
            <div fxLayout="col" fxFlex="100" class="detail-info">
              {{ "No members found" | translate }}
            </div>
          </div>
        }
      </nz-content>
    </nz-layout>
  </div>
</div>
